export const actionTypes = {
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGOUT: 'LOGOUT',
    BALANCE_LOADING: 'BALANCE_LOADING',
    BALANCE_SUCCESS: 'BALANCE_SUCCESS',
    BALANCE_ERROR: 'BALANCE_ERROR',
}
